import loadable from '@loadable/component'

import { cookieAllowlist } from './config/cookie-allowlist'
import { providersCrumbs } from './config/crumbs'
import filterConfig from './config/filter-config'
import { orderings } from './config/orderings'
import routesList from './routes-list'
import { sentenceCase } from './utils/string'

const Provider = loadable(() => import('./components/pages/packages'))

const slugScope = (scope, providerSlug) => {
  if (scope === 'broadband') {
    return providerSlug
  } else if (scope === 'tv') {
    return `tv/${providerSlug}`
  }
}

const commonProviderFields = (
  providerSlug,
  providerFormattedName,
  connectionTypes = ['HOME'],
  scope = 'broadband',
  routeMatch = providerSlug,
  providerListName = providerFormattedName,
  formattedScope = scope,
  previewFlag = false
) => ({
  path: routesList[routeMatch],
  slug: slugScope(scope, providerSlug),
  nonServiceabilityPage: true,
  crumbs: providersCrumbs(providerFormattedName, scope, formattedScope),
  component: Provider,
  scope,
  cookieAllowlist,
  exact: true,
  orderings,
  filterConfig: filterConfig(),
  listnames: (intent = 'provider_of_the_week', provider = providerListName) => ({
    p0: `${sentenceCase(formattedScope)}  - ${sentenceCase(formattedScope)} - Featured Deal`,
    p1: `${sentenceCase(formattedScope)} - Ad - ${intent.toLowerCase()}`,
    p4: `${sentenceCase(formattedScope)} - Ad - ${intent.toLowerCase()} - enhanced`,
    table: `${sentenceCase(formattedScope)} - ${provider} ${sentenceCase(formattedScope)} deals`
  }),
  helmet: {
    canonical: `https://www.uswitch.com${routesList[routeMatch]}/`
  },
  connectionTypes,
  previewFlag
})

export default [
  {
    pageId: 'providers-talk-talk',
    providerId: '12165',
    ...commonProviderFields('talktalk', 'TalkTalk')
  },
  {
    pageId: 'providers-talk-talk-business',
    providerId: '12212',
    ...commonProviderFields('talktalk_business', 'TalkTalk Business', ['BUSINESS'])
  },
  {
    pageId: 'tv-providers-talk-talk',
    providerId: '12165',
    ...commonProviderFields('talktalk', 'TalkTalk', ['HOME'], 'tv', 'tv_talktalk', 'TalkTalk', 'TV')
  },
  {
    pageId: 'tv-providers-now',
    providerId: '12812',
    ...commonProviderFields('now_broadband', 'Now', ['HOME'], 'tv', 'tv_now_tv', 'Now', 'TV')
  },
  {
    pageId: 'providers-plusnet',
    providerId: '12185',
    ...commonProviderFields('plusnet', 'Plusnet')
  },
  {
    pageId: 'providers-bt',
    providerId: '12153',
    ...commonProviderFields('bt', 'BT'),
    embeddedEeveeEntityIds: {
      heroContent: '6SiBISXH7CbpWjFRb8HxxQ',
      modularPage: '78VVHkOd7U7uK1fsrB2fRe',
      author: '1iQj37f6RmSVdm0rCFpRCT'
    }
  },
  {
    pageId: 'tv-providers-bt',
    providerId: '12153',
    ...commonProviderFields('bt', 'BT', ['HOME'], 'tv', 'tv_bt', 'TV')
  },
  {
    pageId: 'providers-ee',
    providerId: '12763',
    ...commonProviderFields('ee', 'EE')
  },
  {
    pageId: 'tv-providers-ee',
    providerId: '12763',
    ...commonProviderFields('ee', 'EE', ['HOME'], 'tv', 'tv_ee', 'EE', 'TV')
  },
  {
    pageId: 'tv-providers-amazon',
    providerId: '12819',
    ...commonProviderFields('amazon', 'Amazon', [], 'tv', 'amazon', 'Amazon', 'TV')
  },
  {
    pageId: 'providers-sky',
    providerId: '12175',
    ...commonProviderFields('sky', 'Sky'),
    embeddedEeveeEntityIds: {
      heroContent: '5XZ84mYgQwNeLQAowb4WRo',
      modularPage: '4j9pIx1cMkP41xwBak56JQ',
      author: '1iQj37f6RmSVdm0rCFpRCT'
    }
  },
  {
    pageId: 'tv-providers-sky',
    providerId: '12175',
    ...commonProviderFields('sky', 'Sky', ['HOME'], 'tv', 'tv_sky', 'Sky', 'TV')
  },
  {
    pageId: 'providers-virgin-media',
    providerId: '12179',
    embeddedEeveeEntityIds: {
      heroContent: '6DNjJODphvr6xzL6xevwzF',
      modularPage: '4MeKCTIczuExUMjV1KwSc3',
      author: '1iQj37f6RmSVdm0rCFpRCT'
    },
    ...commonProviderFields('virgin_media', 'Virgin Media')
  },
  {
    pageId: 'providers-virgin-media-business',
    providerId: '12758',
    ...commonProviderFields('virgin_media_business', 'Virgin Media Business', ['BUSINESS'])
  },
  {
    pageId: 'tv-providers-virgin-media',
    providerId: '12179',
    ...commonProviderFields('virgin_media', 'Virgin Media', ['HOME'], 'tv', 'tv_virgin_media', 'Virgin Media', 'TV')
  },
  {
    pageId: 'providers-vodafone',
    providerId: '12193',
    ...commonProviderFields('vodafone', 'Vodafone')
  },
  {
    pageId: 'providers-hyperoptic',
    providerId: '12774',
    ...commonProviderFields('hyperoptic', 'Hyperoptic')
  },
  {
    pageId: 'providers-now-broadband',
    providerId: '12827',
    ...commonProviderFields('now_broadband', 'NOW Broadband')
  },
  {
    pageId: 'providers-dst',
    providerId: '12189',
    ...commonProviderFields('dst', 'Direct Save Telecom')
  },
  {
    pageId: 'providers-xln',
    providerId: '12737',
    ...commonProviderFields('xln_telecom', 'XLN Telecom', ['HOME'], 'broadband', 'xln_telecom', 'XLN')
  },
  {
    pageId: 'providers-sse',
    providerId: '12792',
    ...commonProviderFields('sse', 'SSE')
  },
  {
    pageId: 'providers-pop-telecom',
    providerId: '12791',
    ...commonProviderFields('pop_telecom', 'Pop Telecom')
  },
  {
    pageId: 'tv-providers-pop-telecom',
    providerId: '12791',
    ...commonProviderFields('pop_telecom', 'Pop Telecom', ['HOME'], 'tv', 'tv_pop_telecom', 'Pop Telecom', 'TV')
  },
  {
    pageId: 'providers-origin',
    providerId: '12803',
    ...commonProviderFields('origin', 'Origin')
  },
  {
    pageId: 'providers-onestream',
    providerId: '12828',
    crumbs: providersCrumbs('Onestream'),
    ...commonProviderFields('onestream', 'Onestream')
  },
  {
    pageId: 'providers-shell-energy-broadband',
    providerId: '12833',
    ...commonProviderFields(
      'shell_energy_broadband',
      'Shell Energy Broadband',
      ['HOME'],
      'broadband',
      'shell_energy_broadband',
      'Shell Energy'
    )
  },
  {
    pageId: 'providers-community-fibre',
    providerId: '12835',
    ...commonProviderFields('community_fibre', 'Community Fibre'),
    nonServiceabilityPage: false,
    questionLedJourney: true,
    returnUrl: '/broadband/providers/community_fibre/'
  },
  {
    pageId: 'providers-kcom',
    providerId: '12837',
    ...commonProviderFields('kcom', 'KCOM')
  },
  {
    pageId: 'providers-gigaclear',
    providerId: '12786',
    ...commonProviderFields('gigaclear', 'Gigaclear')
  },
  {
    pageId: 'providers-cuckoo',
    providerId: '12836',
    ...commonProviderFields('cuckoo', 'Cuckoo')
  }
]
